module.exports = __webpack_public_path__ + "img/finances.87cc996d.png";